import React from "react";
import { Helmet } from "react-helmet-async"; // React Helmet Async import edildi

const Egitimim = () => {
  return (
    <section id="resume" className="resume section">
      {/* SEO Başlık ve Meta Tagları */}
      <Helmet>
        <title>Eğitimim ve Deneyimlerim - Kişisel Web Sitesi</title>
        <link rel="canonical" href="https://hacialikara.com/egitimim" />
        <meta name="description" content="Eğitim ve iş deneyimlerim hakkında bilgi." />
        <meta name="keywords" content="eğitim, deneyim, İngilizce öğretmeni, web geliştirici, sertifikalar" />
        <meta property="og:title" content="Eğitimim ve Deneyimlerim" />
        <meta property="og:description" content="Kişisel web sitemdeki eğitim ve iş deneyimlerim." />
        <meta property="og:image" content="image/iconali.png" />
        <meta property="og:url" content="https://hacialikara.com/egitimim" />
      </Helmet>

      {/* Bölüm Başlığı */}
      <div className="container section-title" data-aos="fade-up">
        <h2>Eğitimim ve Deneyimlerim</h2>
        <div className="title-shape">
          <svg viewBox="0 0 200 20" xmlns="http://www.w3.org/2000/svg">
            <path d="M 0,10 C 40,0 60,20 100,10 C 140,0 160,20 200,10" fill="none" stroke="currentColor" strokeWidth="2"></path>
          </svg>
        </div>
      </div>
      {/* Bölüm Sonu */}

      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="row">
          <div className="col-12">
            <div className="resume-wrapper">
              <div className="resume-block" data-aos="fade-up">
                <h2>İş Deneyimlerim</h2>

                <div className="timeline">
                  <div className="timeline-item" data-aos="fade-up" data-aos-delay="200">
                    <div className="timeline-left">
                      <h4 className="company">Güneş Okulları</h4>
                      <span className="period">Temmuz 2018 — Günümüz</span>
                    </div>
                    <div className="timeline-dot"></div>
                    <div className="timeline-right">
                      <h3 className="position">İngilizce Zümre Başkanı / Ortaokul Öğretmeni</h3>
                      <p className="description">
                        İngilizce Bölüm Başkanı olarak görev yapıyor ve 5-8. sınıflara İngilizce dersleri veriyorum. Yenilikçi müfredat geliştirdim ve AI araçlarını ders planlarına entegre ettim.
                      </p>
                    </div>
                  </div>

                  <div className="timeline-item" data-aos="fade-up" data-aos-delay="300">
                    <div className="timeline-left">
                      <h4 className="company">Freelance Web Tasarım</h4>
                      <span className="period">7 Yıl</span>
                    </div>
                    <div className="timeline-dot"></div>
                    <div className="timeline-right">
                      <h3 className="position">Web Geliştirici & Grafik Tasarımcı</h3>
                      <p className="description">
                        Çeşitli şirketler için e-ticaret, tanıtım ve blog siteleri hazırladım. Web tasarımı, kodlama ve dijital pazarlama alanlarında çalıştım.
                      </p>
                    </div>
                  </div>

                  <div className="timeline-item" data-aos="fade-up" data-aos-delay="400">
                    <div className="timeline-left">
                      <h4 className="company">YDS Yayıncılık</h4>
                      <span className="period">Mayıs 2016 — Mayıs 2017</span>
                    </div>
                    <div className="timeline-dot"></div>
                    <div className="timeline-right">
                      <h3 className="position">Satış Temsilcisi</h3>
                      <p className="description">
                        İngilizce ve Almanca ders kitaplarının satış ve pazarlamasını yönettim.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="resume-block" data-aos="fade-up" data-aos-delay="100">
                <h2>Eğitimim</h2>
                <div className="timeline">
                  <div className="timeline-item" data-aos="fade-up" data-aos-delay="200">
                    <div className="timeline-left">
                      <h4 className="company">Kocaeli Üniversitesi</h4>
                      <span className="period">09.2012 — 06.2017</span>
                    </div>
                    <div className="timeline-dot"></div>
                    <div className="timeline-right">
                      <h3 className="position">İngiliz Dili ve Edebiyatı</h3>
                      <p className="description">
                        İngiliz edebiyatı ve ileri dil çalışmaları üzerine uzmanlaştım.
                      </p>
                    </div>
                  </div>

                  <div className="timeline-item" data-aos="fade-up" data-aos-delay="300">
                    <div className="timeline-left">
                      <h4 className="company">Kocaeli Üniversitesi</h4>
                      <span className="period">09.2016 — 06.2017</span>
                    </div>
                    <div className="timeline-dot"></div>
                    <div className="timeline-right">
                      <h3 className="position">Pedagojik Formasyon Programı</h3>
                      <p className="description">
                        Eğitim metodolojileri ve öğretim teknikleri üzerine uzmanlık kazandım.
                      </p>
                    </div>
                  </div>

                  <div className="timeline-item" data-aos="fade-up" data-aos-delay="400">
                    <div className="timeline-left">
                      <h4 className="company">Bilge Adam</h4>
                      <span className="period">01.2014</span>
                    </div>
                    <div className="timeline-dot"></div>
                    <div className="timeline-right">
                      <h3 className="position">Web ve Grafik Tasarım Programı</h3>
                      <p className="description">
                        Adobe Photoshop ve Illustrator'da ileri düzey beceriler kazandım.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Lisanslar ve Sertifikalar Bölümü */}
              <div className="resume-block" data-aos="fade-up" data-aos-delay="200">
                <h2>Lisanslar ve Sertifikalar</h2>
                <div className="timeline">
                  <div className="timeline-item" data-aos="fade-up" data-aos-delay="200">
                    <div className="timeline-left">
                      <h4 className="company">Cambridge Days Turkey 2021</h4>
                      <span className="period">Şub 2021 tarihinde verildi · Şub 2021 tarihinde süresi bitiyor</span>
                    </div>
                    <div className="timeline-dot"></div>
                    <div className="timeline-right">
                      <p className="description">Cambridge Üniversitesi'nin düzenlediği eğitim programına katıldım.</p>
                    </div>
                  </div>

                  <div className="timeline-item" data-aos="fade-up" data-aos-delay="300">
                    <div className="timeline-left">
                      <h4 className="company">Hybrid English Teaching: Challenges and Solutions</h4>
                      <span className="period">Şub 2021 tarihinde verildi · Şub 2021 tarihinde süresi bitiyor</span>
                    </div>
                    <div className="timeline-dot"></div>
                    <div className="timeline-right">
                      <p className="description">Eğitimde hibrit öğretim teknikleri üzerine bir sertifika aldım.</p>
                    </div>
                  </div>

                  <div className="timeline-item" data-aos="fade-up" data-aos-delay="400">
                    <div className="timeline-left">
                      <h4 className="company">Kocaeli Üniversitesi</h4>
                      <span className="period">Pedagojik Formasyon Programı</span>
                    </div>
                    <div className="timeline-dot"></div>
                    <div className="timeline-right">
                      <p className="description">Pedagojik formasyon programını tamamlayarak öğretim metodolojisi ve tekniklerinde uzmanlık kazandım.</p>
                    </div>
                  </div>

                  <div className="timeline-item" data-aos="fade-up" data-aos-delay="500">
                    <div className="timeline-left">
                      <h4 className="company">Bilge Adam</h4>
                      <span className="period">Web ve Grafik Tasarım</span>
                    </div>
                    <div className="timeline-dot"></div>
                    <div className="timeline-right">
                      <p className="description">Web ve grafik tasarım alanında ileri düzey eğitim aldım.</p>
                    </div>
                  </div>

                  <div className="timeline-item" data-aos="fade-up" data-aos-delay="600">
                    <div className="timeline-left">
                      <h4 className="company">Microsoft Certified Solutions Expert (MCSE)</h4>
                      <span className="period">Yayınlama Şub 2015</span>
                    </div>
                    <div className="timeline-dot"></div>
                    <div className="timeline-right">
                      <p className="description">Microsoft Certified Solutions Expert sertifikasını aldım.</p>
                    </div>
                  </div>

                  <div className="timeline-item" data-aos="fade-up" data-aos-delay="700">
                    <div className="timeline-left">
                      <h4 className="company">ERP İLE MUHASEBE VE FİNANS UYGULAMALARI</h4>
                      <span className="period">Oca 2015 tarihinde verildi</span>
                    </div>
                    <div className="timeline-dot"></div>
                    <div className="timeline-right">
                      <p className="description">ERP tabanlı muhasebe ve finans uygulamalarına dair eğitim aldım.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Egitimim;